import { ColumnDef } from '@tanstack/react-table'
import { ClientDataTable } from 'components/ClientDataTable/ClientDataTable'
import { FbModal } from 'components/UI/Modal'
import { useMemo } from 'react'
import { CSVRow } from '../importer-types'

export function ImportWizardDialogConfirmDeselectMatched({
  show,
  headers,
  data,
  onCancel,
  onAccept,
}: {
  show: boolean
  headers: Record<string, string>
  data: CSVRow[]
  onCancel: () => void
  onAccept: () => void
}) {
  const columnDefs: ColumnDef<CSVRow>[] = useMemo(() => {
    return [
      {
        id: 'input_data',
        header: 'Input Data',
        cell: ({ row }) => {
          const assembledAddress = [
            row.original[headers.street],
            row.original[headers.city],
            row.original[headers.state],
            row.original[headers.zip],
          ]
            .filter(Boolean)
            .join(', ')

          const name = row.original[headers.name] || '-'
          const domain = row.original[headers.domain] || '-'
          const address =
            row.original[headers.full_address] || assembledAddress || '-'

          return (
            <div className="space-y-0.5 text-sm">
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Name:</span> {name}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Domain:</span>{' '}
                {domain}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Address:</span>{' '}
                {address}
              </div>
            </div>
          )
        },
      },
      {
        id: 'matched_data',
        header: 'Matched Data',
        cell: ({ row }) => {
          const chain = row.original.__internal__matched_chain
          const door = row.original.__internal__matched_door

          const name = door?.name || chain?.name || '-'
          const domain = door?.domain || chain?.domain || '-'
          const address = door?.address || '-'

          return (
            <div className="space-y-0.5 text-sm">
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Name:</span> {name}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Domain:</span>{' '}
                {domain}
              </div>
              <div className="text-gray-700">
                <span className="font-medium text-gray-500">Address:</span>{' '}
                {address}
              </div>
            </div>
          )
        },
      },
    ]
  }, [headers])

  if (!show) {
    return null
  }

  return (
    <FbModal
      size="xl"
      title={'Confirm Matches Deselection'}
      description={
        'You have deselected matches that you do not think are correct. Please review and confirm. You will be able to review it later.'
      }
      disableCloseIcon
      open={true}
      cancelButtonText="Cancel"
      acceptButtonText="Confirm"
      onCancel={onCancel}
      onAccept={onAccept}
    >
      <ClientDataTable data={data} columns={columnDefs} enableSorting />
    </FbModal>
  )
}
